// ◉ xlVISION · Powering Business Together!
// © ExcelVision, Lda. — Braga, Portugal
// ( ·:·●●·:· ) xlVISION | Powering Business Together!
//
// ============================================================================
// A FRASE DE UMA RECUSA DO DESFAZER — o que o planeador lê, sem o código do erro
// ============================================================================
//
// 📗 Cliente, 2026-09-30: *«existe uma nota chata que é a da classe_do_inverso»* — o ecrã tinha
//    citado o nome de uma tabela. A varredura (regra 8) achou a MESMA falha por outra porta: as
//    recusas do desfazer, do refazer e do «Reverter» chegavam ao ecrã como
//    `nao_se_desfaz_daqui — <frase>`, e os passos que falham dentro de um gesto como
//    `mudar_executor: registo_incompleto — <frase>` — o código do erro e o da acção, à frente
//    da frase que o servidor já escrevera em português.
//
// ⚙ Para quem programa: o servidor manda `erro` (identificador estável, para o código e para o
//   travão de recusas — `recusaDoCorpo` continua a recebê-lo) e `detalhe` (a frase). O ecrã
//   mostra SÓ a frase. Uma só formulação para os sete sítios (Desfazer.tsx ×4, Diario.tsx ×3);
//   `frases-do-inverso-sem-codigo.test.ts` recusa voltar a interpolar `corpo['erro']`/`x.erro`.
// ============================================================================

/** O que o servidor devolve numa recusa — só o que aqui se lê. */
export interface CorpoComDetalhe {
  readonly detalhe?: unknown;
}

/** Quando o servidor não trouxe frase, diz-se o que fazer — nunca o código do erro. */
export const FRASE_SEM_DETALHE =
  'não foi possível concluir. Recarregue o diário e tente outra vez.';

/** A frase de uma recusa: a do servidor, ou a de omissão. Nunca o código do erro nem o HTTP. */
export function fraseDaRecusa(corpo: CorpoComDetalhe | null | undefined): string {
  const d = corpo?.detalhe;
  return typeof d === 'string' && d.trim() !== '' ? d : FRASE_SEM_DETALHE;
}

/** Um passo de um gesto que não se aplicou — a frase dele, sem o nome da acção nem o erro. */
export function fraseDoPassoFalhado(x: { readonly detalhe?: string | undefined }): string {
  return x.detalhe !== undefined && x.detalhe.trim() !== '' ? x.detalhe : 'este passo não foi aplicado.';
}
